import { trpc } from '@/shared/api';

export const usePortfoliosQuery = (
  input: { categoryId?: string; page: number },
  options: { enabled?: boolean } = {},
) => trpc.portfolio.list.useQuery(input, { enabled: options.enabled ?? true, retry: false });
